import { render, staticRenderFns } from "./InlineAdvertisements.vue?vue&type=template&id=83dcc18a"
import script from "./InlineAdvertisements.vue?vue&type=script&lang=ts"
export * from "./InlineAdvertisements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports